export const UPDATE_CARE_PROVIDER_SUCCESS = 'UPDATE_CARE_PROVIDER_SUCCESS';

export const updateCareProviderSuccess = ({ careProvider }) => ({
    type: UPDATE_CARE_PROVIDER_SUCCESS,
    payload: {
        careProvider,
    },
});
